import { ManageMetadataEditDrawerContent } from '@modules/integrationsV2/components/ManageMetadataSection/ManageMetadataEditDrawerContent';
import { ManageMetadataEditDrawerHeader } from '@modules/integrationsV2/components/ManageMetadataSection/ManageMetadataEditDrawerHeader';
import {
  IntegrationSource,
  ManageMetadataTableRow,
} from '@modules/integrationsV2/types';
import { Drawer, Stack } from '@mui/material';

interface ManageMetadataEditDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  metadataToEdit: ManageMetadataTableRow | undefined;
  onNext?: () => void;
  onPrevious?: () => void;
  currentFieldIndex: number;
  totalFieldCount: number;
  integrationSource: IntegrationSource;
  onEditUnifiedFieldButtonClick?: (metadataKey?: string) => void;
  openCreateUnifiedFieldDrawer?: (metadataKey?: string) => void;
}

export const ManageMetadataEditDrawer = ({
  isOpen,
  onClose,
  metadataToEdit,
  onNext,
  onPrevious,
  currentFieldIndex,
  totalFieldCount,
  integrationSource,
  onEditUnifiedFieldButtonClick,
  openCreateUnifiedFieldDrawer,
}: ManageMetadataEditDrawerProps) => {
  if (!metadataToEdit) {
    return null;
  }

  return (
    <Drawer anchor="right" open={isOpen} onClose={onClose}>
      <Stack width="45vw" minWidth={600} height="100%">
        <ManageMetadataEditDrawerHeader
          onNext={onNext}
          onPrevious={onPrevious}
          currentFieldIndex={currentFieldIndex}
          totalFieldCount={totalFieldCount}
          integrationSource={integrationSource}
        />
        <ManageMetadataEditDrawerContent
          metadataToEdit={metadataToEdit}
          onClose={onClose}
          integrationSource={integrationSource}
          onEditUnifiedFieldButtonClick={onEditUnifiedFieldButtonClick}
          openCreateUnifiedFieldDrawer={openCreateUnifiedFieldDrawer}
        />
      </Stack>
    </Drawer>
  );
};
